import { useUtilsStyles } from '@components/utils/Styles'
import { Button, ButtonProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FocusRing } from '@react-aria/focus'
import clsx from 'clsx'
import React from 'react'

import { ButtonText } from '../utils/typography'

const useStyles = makeStyles(theme => ({
  button: {
    '&:disabled': {
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[400],
        cursor: 'not-allowed',
      },
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.common.black,
    },
    '&:disabled $text': {
      color: theme.palette.common.black,
    },
    '&:hover, &:focus': {
      backgroundColor: theme.palette.secondary.dark,
    },
    backgroundColor: theme.palette.secondary.main,
    borderRadius: theme.shape.borderRadius * 5,
    color: theme.palette.common.white,
    padding: theme.spacing(1.5, 5),
  },
  text: {
    color: theme.palette.common.white,
  },
}))

const SecondaryButton = ({ children, className, ...buttonProps }: ButtonProps) => {
  const { button, text } = useStyles()
  const { focusRing } = useUtilsStyles()
  return (
    <FocusRing within focusRingClass={focusRing}>
      <Button className={clsx(button, className)} {...buttonProps}>
        <ButtonText className={text}>{children}</ButtonText>
      </Button>
    </FocusRing>
  )
}

export default SecondaryButton as typeof Button
